import { BaseRequest } from "./base-request";

export interface IShareRequestFileArgs {
    attachments: Array<string>;
}

export class ShareRequestFile extends BaseRequest {

    attachments: Array<string>;

    constructor(args: IShareRequestFileArgs) {
        super();
        this.attachments = args.attachments;
    }
}



// WEBPACK FOOTER //
// ./src/vas/services/share/file-request.ts